<div [ngClass]="{'sidebar-collapsed': isCollapsed, 'sidebar-expanded': !isCollapsed}" class="sidebar shadow-sm">
    <div class="logo-container py-2">
       <img src="logo-white.png" class="log-img-side">
        <i class="bi bi-justify collaspe-btn" data-bs-toggle="tooltip" data-bs-placement="top" title="{{ 'Collapse menu' | translate }}" (click)="toggleSidebar()"></i>
    </div>

    <div class="col-12 mb-3">
        <p class="label-line"></p>
    </div>

    <div class="profile px-3">
        <div class="profile-img-container">
            <img src="profile.png" alt="Profile" class="profile-img" />
            <i class="fa-solid fa-circle-check profile-check" style="border: 1px solid #FFF;"></i>
        </div>
        <div class="profile-info ms-1">
            <span class="profile-name">{{userName}}</span>
            <span class="profile-role">{{userRole}}</span>
        </div>
    </div>

    <div class="col-12 mt-3">
        <p class="label-line"></p>
    </div>

    <div class="search-box" data-bs-toggle="tooltip" data-bs-placement="top" title="{{ 'Search Menu Item' | translate }}">
        <input type="text" placeholder="{{ 'Search Memu' | translate }}" class="search-input" [(ngModel)]="searchQuery" (ngModelChange)="onSearchMenu($event)" />
        <i class="bi bi-search search-icon mt-1"></i>
    </div>
    
    <div class="col-12 mt-3">
        <span class="show-text">{{ 'Menu' | translate }}</span>
    </div>
    
    <div class="scrollable-y">
      <ul class="nav flex-column">
       <li class="nav-item" *ngFor="let menu of menuItems; trackBy: trackByFn">

    <!-- MAIN MENU -->
      <a *ngIf="menu.subMenu.length === 0" [ngClass]="{'active-submenu': menu.isSelected}" [routerLink]="menu.link" (click)="selectMenu(menu)"class="nav-link sub-nav-link">

        <i class="{{ menu.icon }}"></i>

        <span class="link_name">
          {{ menu.name | translate }}
        </span>
      </a>


    <a class="nav-link" *ngIf="menu.subMenu.length > 0"
       (click)="selectMenu(menu)">
      <i class="{{ menu.isOpen ? menu.openIcon : menu.icon }}"
         [ngClass]="{'active-arrow': menu.isSelected}">
      </i>

      <span class="link_name"
            [ngClass]="{'active-arrow': menu.isSelected}">
        {{ menu.name | translate }}
      </span>

      <i class="indicator fa-solid"
         [ngClass]="{
           'fa-chevron-right': !menu.isOpen,
           'fa-chevron-down': menu.isOpen,
           'active-arrow': menu.isSelected
         }">
      </i>
    </a>

    <!-- SUB MENU -->
    <ul class="sub-menu" *ngIf="menu.isOpen">

      <li class="nav-item sub-menu-link"
          *ngFor="let subMenu of menu.subMenu; trackBy: trackByFnForSubMenu">

        <!-- NORMAL SUB MENU -->
        <a *ngIf="!subMenu.innerSubMenu"
           class="nav-link sub-nav-link"
           [ngClass]="{'active-submenu': subMenu.isSelected}"
           [routerLink]="subMenu.link"
           (click)="selectSubMenu(subMenu, menu)">

          <i class="{{subMenu.icon}}"></i>
          <span class="sub_menu_name">{{ subMenu.title | translate }}</span>
        </a>

        <!-- PARENT SUB MENU -->
        <a *ngIf="subMenu.innerSubMenu"
           class="nav-link sub-nav-link"
           (click)="toggleInnerSubMenu(subMenu, $event)">

          <i class="{{subMenu.icon}}"></i>
          <span class="sub_menu_name">{{ subMenu.title | translate }}</span>

          <i class="fa-solid p-5"
             [ngClass]="{
               'fa-chevron-right': !subMenu.isOpen,
               'fa-chevron-down': subMenu.isOpen
             }">
          </i>
        </a>

        <!-- INNER SUB MENU -->
        <ul class="sub-menu" *ngIf="subMenu.innerSubMenu && subMenu.isOpen">
          <li class="nav-item sub-menu-link"
              *ngFor="let inner of subMenu.innerSubMenu">

            <a class="nav-link sub-nav-link"
               [ngClass]="{'active-submenu': inner.isSelected}"
               [routerLink]="inner.link"
               (click)="selectSubMenu(inner, menu)">
              <span class="sub_menu_name">
                {{ inner.title | translate }}
              </span>
            </a>

          </li>
        </ul>

      </li>
    </ul>
        </li>
    </ul>
  </div>
</div>
